import Vue from 'vue';
export const ngVueEventBus = new Vue();

export const EVENT_SAVED_INSIGHTS_UPDATED = 'EVENT_SAVED_INSIGHTS_UPDATED';
export const EVENT_SHOW_TOASTER = 'EVENT_SHOW_TOASTER';

export const EVENT_START_PLAYER = 'EVENT_START_PLAYER';
export const EVENT_STOP_PLAYER = 'EVENT_STOP_PLAYER';


export const EVENT_CAMPAIGNS_UPDATED = 'EVENT_CAMPAIGNS_UPDATED';
export const EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED = 'EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED';

export const EVENT_API_TOKENS_UPDATED = 'EVENT_API_TOKENS_UPDATED';
export const EVENT_API_TOKEN_CREATED = 'EVENT_API_TOKEN_CREATED';
